import { createContext } from 'react';
import EditBenefitContext from 'types/contexts/EditBenefitContext';

export default createContext({} as EditBenefitContext);
